<template>
  <div class="container">
    <JournalHeader />

    <div class="countries-container">
      <JournalCountries
        :list="countries"
        link-type="country"
        :loading="journalStore.isLoadingCountries"
      />
    </div>
    <JournalArticles />
    <JournalEditorialColumn />
    <JournalPopularArticles />
  </div>
</template>

<script lang="ts" setup>
  import { useHead } from '@unhead/vue';
  import { onMounted, onBeforeMount, ref } from 'vue';

  import { trackEvent } from '@/services/analytics';
  import JournalArticles from '@/pages/journal/features/JournalArticles.vue';
  import JournalEditorialColumn from '@/pages/journal/features/JournalEditorialColumn.vue';
  import JournalHeader from '@/pages/journal/features/JournalHeader.vue';
  import JournalPopularArticles from '@/pages/journal/features/JournalPopularArticles.vue';
  import JournalCountries from '@/features/JournalCountries/ui/JournalCountries.vue';

  import type { GeoItem } from '@/shared/models/journal';
  import { useJournalStore } from '@/shared/stores/journal';

  const journalStore = useJournalStore();

  const title = 'Журнал Трипстера — вдохновляем на путешествия.';
  const description =
    'Вдохновляем на путешествия, помогаем собраться в поездку и увидеть всё самое главное и необычное.';

  const ogImage = ref('https://static2.tripster.ru/img/ogLogo.jpg');

  const countries = ref<GeoItem[]>([]);

  useHead({
    title,
    link: [
      {
        rel: 'canonical',
        href: `${window.location.origin}${window.location.pathname}`,
      },
    ],
    meta: [
      {
        name: 'description',
        content: description,
      },
      {
        property: 'og:url',
        content: `${window.location.origin}${window.location.pathname}`,
      },
      {
        property: 'og:title',
        content: title,
      },
      {
        property: 'og:description',
        content: description,
      },
      {
        content: () => ogImage.value,
        property: 'og:image',
      },
      {
        name: 'twitter:card',
        content: 'summary_large_image',
      },
      {
        name: 'twitter:image',
        content: () => ogImage.value,
      },
    ],
  });

  const getCountries = async () => {
    await journalStore.getCountries();
    countries.value = journalStore.countries;
  };

  const getArticles = async () => {
    await journalStore.getArticles();
    ogImage.value = 'https://static2.tripster.ru/img/ogLogo.jpg';
  };

  getArticles();

  onMounted(() => trackEvent('journal:pageview'));

  onBeforeMount(() => {
    getCountries();
  });
</script>

<style lang="scss" scoped>
  .container {
    padding-bottom: 60px;

    @include tablet {
      padding-bottom: 92px;
    }

    @include mobile {
      padding-bottom: 40px;
    }
  }

  .countries-container {
    margin-top: 32px;

    @include tablet {
      margin-top: 28px;
    }

    @include mobile {
      margin-top: 24px;
    }
  }
</style>
